import { render, staticRenderFns } from "./SystemPrograms.vue?vue&type=template&id=346f2e24&"
import script from "./SystemPrograms.vue?vue&type=script&lang=js&"
export * from "./SystemPrograms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('346f2e24')) {
      api.createRecord('346f2e24', component.options)
    } else {
      api.reload('346f2e24', component.options)
    }
    module.hot.accept("./SystemPrograms.vue?vue&type=template&id=346f2e24&", function () {
      api.rerender('346f2e24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SystemPrograms.vue"
export default component.exports